import { groupIntoMeasures, getBeatsPerMeasure } from './musicTheory.js'

function serializeVoiceNotes(notes) {
  if (!notes?.length) return []
  return notes.map((n) => {
    if (n.isRest) return `rest:${n.duration}`
    return `${n.pitch}:${n.duration}`
  })
}

/**
 * kordAI 화성 분석 입력: { key, timeSignature, measures } → analyzeHarmonyPayload()에 전달
 */
export function buildAnalyzeHarmonyBody(score, keySignature, timeSignature, theoryBase = 'baek') {
  const beatsPerMeasure = getBeatsPerMeasure(timeSignature)
  const sopMeas = groupIntoMeasures(score.soprano ?? [], beatsPerMeasure)
  const altMeas = groupIntoMeasures(score.alto ?? [], beatsPerMeasure)
  const tenMeas = groupIntoMeasures(score.tenor ?? [], beatsPerMeasure)
  const basMeas = groupIntoMeasures(score.bass ?? [], beatsPerMeasure)
  const n = Math.max(sopMeas.length, altMeas.length, tenMeas.length, basMeas.length, 1)

  const measures = []
  for (let i = 0; i < n; i++) {
    measures.push({
      measure: i + 1,
      soprano: serializeVoiceNotes(sopMeas[i]?.notes),
      alto: serializeVoiceNotes(altMeas[i]?.notes),
      tenor: serializeVoiceNotes(tenMeas[i]?.notes),
      bass: serializeVoiceNotes(basMeas[i]?.notes),
    })
  }

  return {
    key: keySignature,
    timeSignature,
    theoryBase,
    measures,
  }
}
